import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  // Kind, value, active, remove. The value column takes the slack because a
  // binding value is a user id or an endpoint address — the long field.
  bindingRow: {
    display: 'grid',
    gridTemplateColumns: '4fr 8fr 3fr auto',
    gap: theme.spacing(1),
    alignItems: 'center',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  switches: {
    marginTop: theme.spacing(2)
  },
  submit: {
    marginTop: theme.spacing(2)
  }
}))
